export default function calculateDuration(start, finish) {
  return new Date(finish).valueOf() - new Date(start).valueOf();
}
